import { handleActions } from 'redux-actions';
import {
  setAutoTieoutWorkpaperReference,
  removeAutoTieoutWorkpaperReference,
} from 'store/actions/auto-tieout/workpaper-details-action';

import WorkpaperDetails from 'models/api/auto-tieout/workpaper-details-api-model';

export default handleActions(
  {
    [setAutoTieoutWorkpaperReference]: (workpaperDetails, { payload }) => {
      return workpaperDetails.setLoaded(payload);
    },
    [removeAutoTieoutWorkpaperReference]: () => {
      return new WorkpaperDetails();
    },
  },
  new WorkpaperDetails(),
);
